var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoConsultation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.443 17.0167H5.1763C2.54297 17.0167 1.66797 15.2667 1.66797 13.5083V6.49167C1.66797 3.85834 2.54297 2.98334 5.1763 2.98334H10.443C13.0763 2.98334 13.9513 3.85834 13.9513 6.49167V13.5083C13.9513 16.1417 13.068 17.0167 10.443 17.0167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2659 14.25L13.9492 12.625V7.36665L16.2659 5.74165C17.3992 4.94999 18.3326 5.43332 18.3326 6.82499V13.175C18.3326 14.5667 17.3992 15.05 16.2659 14.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58203 9.16669C10.2724 9.16669 10.832 8.60704 10.832 7.91669C10.832 7.22633 10.2724 6.66669 9.58203 6.66669C8.89168 6.66669 8.33203 7.22633 8.33203 7.91669C8.33203 8.60704 8.89168 9.16669 9.58203 9.16669Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoConsultation);
export default __webpack_public_path__ + "static/media/video_consultation.c8301084dc99be613d16233895de08e5.svg";
export { ForwardRef as ReactComponent };